<template>
  <AppUpdateScreen class="md:hidden" />
</template>

<script>
import AppUpdateScreen from '../components/appData/AppUpdateScreen.vue'

export default {
  name: 'home',
  components: { AppUpdateScreen },
  data() {
    return {}
  },
  beforeUnmount() {},
  mounted() {},
  methods: {},
}
</script>
